<div class="sidenav">
    <div class="logo"></div>
    <mat-nav-list>
        <div *ngIf="user?.CurrentRole.isAdmin || user?.CurrentRole.isDistrictWebsite">
            <div mat-subheader>District Calendar</div>
            <a mat-list-item [routerLink]="RoutePath.Home" routerLinkActive="active">
                <mat-icon>dashboard</mat-icon>
                <span class="linkText">Dashboard</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.Events" routerLinkActive="active">
                <mat-icon>event</mat-icon>
                <span class="linkText">Events</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.CalendarWidget" routerLinkActive="active">
                <mat-icon>calendar_view_month</mat-icon>
                <span class="linkText">Calendar Widget</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.Bulletin" routerLinkActive="active">
                <mat-icon>campaign</mat-icon>
                <span class="linkText">Bulletin</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.HallOfFame" routerLinkActive="active">
                <mat-icon>emoji_events</mat-icon>
                <span class="linkText">Hall of Fame</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.Categories" routerLinkActive="active">
                <mat-icon>category</mat-icon>
                <span class="linkText">Categories</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.Schools" routerLinkActive="active">
                <mat-icon>school</mat-icon>
                <span class="linkText">Schools</span>
            </a>
        </div>

        <div *ngIf="user?.CurrentRole.isAdmin || user?.CurrentRole.isLegislative">
            <div mat-subheader>Legislative</div>
            <a mat-list-item [routerLink]="RoutePath.LegislationInfo" routerLinkActive="active">
                <mat-icon>gavel</mat-icon>
                <span class="linkText">Legislative Items</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.LegislationForm" routerLinkActive="active">
                <mat-icon>note_alt</mat-icon>
                <span class="linkText">Legislative Form</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.LegislationGroups" routerLinkActive="active">
                <mat-icon>contact_mail</mat-icon>
                <span class="linkText">Legislative Members/Groups</span>
            </a>
        </div>

        <div *ngIf="user?.CurrentRole.isAdmin">
            <div mat-subheader>Administration</div>
            <a mat-list-item [routerLink]="RoutePath.UserRoles" routerLinkActive="active">
                <mat-icon>people</mat-icon>
                <span class="linkText">Users and Roles</span>
            </a>
            <!-- <div mat-subheader>Feeds</div>
            <a mat-list-item [routerLink]="RoutePath.Feeds" routerLinkActive="active">
                <mat-icon>rss</mat-icon>
                <span class="linkText">Feeds</span>
            </a>
            <a mat-list-item [routerLink]="RoutePath.Feeds2" routerLinkActive="active">
                <mat-icon>rss</mat-icon>
                <span class="linkText">Feeds2</span>
            </a> -->
            <a mat-list-item *ngIf="IsDevSite" [routerLink]="RoutePath.DevTestPage" routerLinkActive="active">
                <mat-icon>construction</mat-icon>
                <span class="linkText">Test Page</span>
            </a>
        </div>


        <!-- <ul class="topmenu">
      <li>
        <a mat-list-item (click)="openSubmenu = !openSubmenu" href="javascript:void(0)">
          <mat-icon>devices</mat-icon>
          <span>Test Sub Menu</span><mat-icon class="expand-icon" [ngClass]="{'expand':!openSubmenu, 'collapse': openSubmenu}"></mat-icon>
        </a>
        <ul class="submenu" [ngClass]="{'collapsed':!openSubmenu, 'expanded': openSubmenu}">
          <li><a mat-list-item routerLink="/login" routerLinkActive="active"><span>Grid</span></a></li>
          <li><a mat-list-item routerLink="/" routerLinkActive="active"><span>Alerts</span></a></li>
          <li><a mat-list-item routerLink="/" routerLinkActive="active"><span>Buttons</span></a></li>
          <li><a mat-list-item routerLink="/" routerLinkActive="active"><span>Typography</span></a></li>
        </ul>
      </li>
    </ul> -->
    </mat-nav-list>
</div>
